module.exports = __webpack_public_path__ + "img/jiankonghui.c6856c1a.png";